import { useState } from "react";
import VideoFullScreen from "./VideoFullScreen";
import { S3ImageFullScreen } from "./S3ImageFullScreen";
import { S3ImageProps } from "./S3Image";

interface MediaFullScreenProps {
  keyFrame?: string;
  mediaOutput?: string;
  s3ImageFullScreenProps?: Omit<S3ImageProps, "s3Key" | "onClickVideoIcon">;
  height?: number | string;
}

export const MediaFullScreen = ({
  keyFrame = "",
  mediaOutput,
  s3ImageFullScreenProps,
  height = 40,
}: MediaFullScreenProps) => {
  const [videoUrl, setVideoUrl] = useState("");

  const handleVideoUrl = (url: string) => () => {
    setVideoUrl(url);
  };

  return (
    <>
      {!!videoUrl && (
        <VideoFullScreen
          signedUrl={videoUrl}
          open={!!videoUrl}
          onClose={handleVideoUrl("")}
        />
      )}
      <S3ImageFullScreen
        {...s3ImageFullScreenProps}
        sx={{
          width: "100%",
          maxHeight: height,
          maxWidth: "120px",
          borderRadius: "8px",
        }}
        s3Key={keyFrame}
        onClickVideoIcon={mediaOutput ? handleVideoUrl(mediaOutput) : undefined}
      />
    </>
  );
};
